// extracted by mini-css-extract-plugin
export default {"eventDescriptionText":"PurchaseTicketPage_eventDescriptionText__k9yG0"};